module.exports = __webpack_public_path__ + "static/media/wizards-grey.c218309a.svg";